export enum HTMLData_Source {
  HTML = 'HTML',
  ADSENSE = 'ADSENSE',
  AI = 'AI',
  UNRECOGNIZED = 'UNRECOGNIZED',
}